import { useAppDispatch, useAppSelector } from 'src/hooks';
import { FormField2, IDynamicFormValue } from 'src/lib';
import { IFilterObj } from 'src/components/filters';
import { useEffect, useState } from 'react';
import { getGridDataForAsAndToBeV2 } from '../../store/simulator-summary-slice-async-thunks';
import { fetchAsIsBarChartData } from '../../api/simulation-summary-api';
import getLocalFiltersPayload from '../../../planner_v2/utils/utils';
import { BarChartDetails } from '../../types/simulation-summary.model';

export default function useAsIsToBeHook({
  sourceId,
  scenarioId,
  moduleId,
  plannerModuleId,
  mode = 'summary',
  isTargetEnabled = false
}: {
  sourceId: number;
  scenarioId: number;
  moduleId: number;
  plannerModuleId: number;
  mode?: 'summary' | 'comparison';
  isTargetEnabled: boolean
}) {
  const appDispatch = useAppDispatch();
  const { fetchingGridData, asIs, toBe } = useAppSelector(
    (state) => state.asIsToBeV2
  );

  const [barCharts, setBarCharts] = useState<BarChartDetails[]>([]);
  const [isFetchingBarCharts, setIsFetchingBarCharts] = useState(false);
  const keys = barCharts.map((data: BarChartDetails) => data.metric);
  const dummyCharts = new Array(14 - keys.length).fill(0);
  //const isTargetEnabled = useAppSelector((state)=> state.scenarioComparison.isTargetEnabled)
  const bool_currency_flag = mode === 'comparison' ? isTargetEnabled : undefined;

  //let filters: IFilterObj[];
  let localFilterFormFields: FormField2[];
  let localFilterFormValue: IDynamicFormValue;


  const gridDataFetchWrapper = ({
    filters,
    localFilterFormFields,
    localFilterFormValue
  }: {
    filters: IFilterObj[];
    localFilterFormFields: FormField2[];
    localFilterFormValue: IDynamicFormValue;
  }) =>
    appDispatch(
      getGridDataForAsAndToBeV2({
        sourceId,
        plannerModuleId,
        moduleId,
        scenarioId,
        filters,
        localFilterFormFields,
        localFilterFormValue,
        ...(bool_currency_flag != undefined && { currency_toggle: isTargetEnabled })
      })
    );

  const getAsIsBarChartData = ({
    filters,
    localFilterFormFields,
    localFilterFormValue
  }: {
    filters: IFilterObj[];
    localFilterFormFields: FormField2[];
    localFilterFormValue: IDynamicFormValue;
  }) => {
    setIsFetchingBarCharts(true);
    const localFilter = getLocalFiltersPayload(
      localFilterFormValue,
      localFilterFormFields
    );
    return fetchAsIsBarChartData(
      moduleId,
      sourceId,
      scenarioId,
      filters,
      localFilter,
      bool_currency_flag
    )
      .then((response) => {
        setBarCharts(response.metrics);
      })
      .finally(() => {
        setIsFetchingBarCharts(false);
      });
  };

  return {
    asIs,
    toBe,
    gridDataFetchWrapper,
    getAsIsBarChartData,
    fetchingGridData,
    barCharts,
    isFetchingBarCharts,
    dummyCharts
  };
}
